<template>
  <div class="fshr-simple-vue-gallery">
    <span
      @click.stop="prevPic"
      v-if="is_prev_rendered"
      class="fshr-simple-vue-gallery--prev"
      ><i class="fshr-icon fshr-icon--caretLeft"></i
    ></span>
    <transition-group name="fade">
      <img
        v-for="(img, indx) in images"
        class="fshr-tripCard__img"
        :class="{ 'fshr-tripCard__img--visible': indx === index }"
        v-if="indx === index"
        v-lazy="img.src"
        :alt="alt"
        :key="indx"
        v-touch:swipe.left="swipeHandlerLeft"
        v-touch:swipe.right="swipeHandlerRight"
      />
    </transition-group>
    <span
      @click.stop="nextPic"
      v-if="is_next_rendered"
      class="fshr-simple-vue-gallery--next"
      ><i class="fshr-icon fshr-icon--caretRight"></i
    ></span>
    <div class="fshr-simple-vue-gallery-nav">
      <ul
        class="fshr-simple-vue-gallery-nav-inner"
        v-if="images.length > 1"
        :style="shiftValueStyle"
      >
        <li
          v-for="(img, indx) in images"
          :class="{ active: indx === index }"
          @click.stop="chooseImg(indx)"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
import VueLazyload from "vue-lazyload";
import Vue from "vue";
import Vue2TouchEvents from "vue2-touch-events";

Vue.use(Vue2TouchEvents);
Vue.use(VueLazyload);

export default {
  name: "SimpleGallery",
  data: function () {
    return {
      index: 0,
      visual_index: 0,
      length_of_one_dot: 18,
      lap: 0,
      shifted_dots: 0,
      shifting_by: 3,
    };
  },
  props: {
    images: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
    alt: {
      required: true,
      type: String,
    },
  },
  methods: {
    swipeHandlerLeft: function () {
      if (this.index < this.images.length - 1) {
        this.nextPic();
      }
    },
    swipeHandlerRight: function () {
      if (this.index > 0) {
        this.prevPic();
      }
    },
    nextPic: function () {
      this.index++;
      this.recalculateShiftOfNav();
    },
    prevPic: function () {
      this.index--;
      this.recalculateShiftOfNav();
    },
    chooseImg: function (indx) {
      this.index = indx;
      this.recalculateShiftOfNav();
    },
    recalculateShiftOfNav: function () {
      /*if((this.index-4) % 3 === 0 ){
                    let moveIndex = this.index - 1;
                    if((moveIndex + 5) > this.images.length){
                        let difference = (this.index + 5) - this.images.length;
                        moveIndex - difference;
                    }
                    this.moveStartTo(moveIndex);
                }else if (this.index % 3 === 0 ){
                    let moveIndex = this.index - 3;
                    this.moveStartTo(moveIndex);
                }*/

      var laps = Math.ceil(this.index / 3);
      if (laps > 0) {
        laps = laps - 1;
      }
      var moveDots = laps * 3;

      if (moveDots + 5 >= this.images.length) {
        moveDots = moveDots - (moveDots + 5 - (this.images.length - 1));
      }
      this.moveStartTo(moveDots);
    },
    moveStartTo: function (index) {
      this.shifted_dots = index;
    },
  },
  computed: {
    is_next_rendered: function () {
      return this.index + 1 !== this.images.length;
    },
    is_prev_rendered: function () {
      return this.index !== 0;
    },
    shiftValue: function () {
      return this.shifted_dots * this.length_of_one_dot;
    },
    shiftValueStyle: function () {
      return {
        left: "-" + this.shiftValue + "px",
      };
    },
  },
};
</script>

<style scoped>
.fshr-simple-vue-gallery {
  position: relative;
  height: 100%;
}

.fshr-simple-vue-gallery .fshr-simple-vue-gallery--prev {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 8;

  color: white;
  cursor: pointer;
  font-size: 20px;
  text-shadow: 0px 0px 6px rgba(0, 0, 0, 0.85);

  padding: 15px;
  display: flex;
  align-items: center;
}

.fshr-simple-vue-gallery .fshr-simple-vue-gallery--next {
  position: absolute;
  right: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 8;

  color: white;
  cursor: pointer;
  font-size: 20px;
  text-shadow: 0px 0px 6px rgba(0, 0, 0, 0.85);

  padding: 15px;
  display: flex;
  align-items: center;
}

.fshr-simple-vue-gallery .fshr-tripCard__img {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  max-width: 100%;
  /*opacity: 0;
        transition: opacity 500ms ease-in-out;*/
}

.fshr-simple-vue-gallery .fshr-tripCard__img.fshr-tripCard__img--visible {
  /*opacity: 1;*/
}

.fshr-simple-vue-gallery-nav {
  position: absolute;
  bottom: 10px;
  justify-content: center;
  left: 50%;
  transform: translateX(-50%);
  padding: 0px;
  margin: 0px;
  line-height: 1;
  max-width: 108px;
  overflow: hidden;
}

.fshr-simple-vue-gallery-nav-inner {
  list-style: none;
  position: relative;
  left: 0px;
  padding: 0px;
  white-space: nowrap;
  margin: 0px;
  transition: left 500ms ease-in-out;
}

.fshr-simple-vue-gallery-nav li {
  cursor: pointer;
  border-radius: 50%;
  height: 12px;
  width: 12px;
  margin: 3px 3px;
  background-color: white;
  opacity: 0.5;
  display: inline-block;
}

.fshr-simple-vue-gallery-nav li.active {
  opacity: 0.8;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
